import React, {Component, ErrorInfo, ReactNode} from 'react';
import ErrorFallbackCustom from "@ui/errorBoundary/ErrorFallbackCustom";

interface IProps {
    children: ReactNode
    resetKey?: string
}

interface IState {
    error: Error | null
}

class ErrorBoundaryCustom extends Component<IProps, IState> {

    state: IState = {
        error: null,
    }

    static getDerivedStateFromError(error: Error): IState {
        return {error}
    }

    componentDidCatch(error: Error, errorInfo: ErrorInfo) {
        console.error(error, errorInfo.componentStack)
    }

    componentDidUpdate(prevProps: IProps) {
        if (this.state.error && prevProps.resetKey !== this.props.resetKey) {
            this.reset()
        }
    }

    reset = () => {
        this.setState({error: null})
    }

    render() {
        if (this.state.error) {
            return (
                <ErrorFallbackCustom
                    error={this.state.error}
                    onReset={this.reset}
                />
            )
        }
        return this.props.children
    }
}

export default ErrorBoundaryCustom;
